import { render, staticRenderFns } from "./DodajKontrolePredelava.vue?vue&type=template&id=fba1d0d6&"
import script from "./DodajKontrolePredelava.vue?vue&type=script&lang=js&"
export * from "./DodajKontrolePredelava.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports